import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { acmGroupPermissions } from './groups/group-names/acm-permissions';

/**
 * This service is responsible for providing dynamic permission sets
 * for components. The dynamism is important because it allows the permissions
 * to be changed at runtime. Dynamic permission sets may come into play if the
 * UI allows the user to change things such as a targeted database schema.
 */
@Injectable({
    providedIn: 'root',
})
export class PermissionsService {
    public permissions$ = new BehaviorSubject(acmGroupPermissions);
}
